import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=3f1ef73b&scoped=true&"
import script from "./recycleBin.vue?vue&type=script&lang=ts&setup=true&"
export * from "./recycleBin.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./recycleBin.vue?vue&type=style&index=0&id=3f1ef73b&prod&scoped=true&lang=less&"
import style1 from "./recycleBin.vue?vue&type=style&index=1&id=3f1ef73b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ef73b",
  null
  
)

export default component.exports